"use client";

import React from "react";
import Link from "next/link";
import { Card, CardBody, CardFooter, CardTitle } from "reactstrap";
import styles from "./LinkCard.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

interface LinkCardProps {
  oldSchoolLink?: boolean;
  title: string;
  linkText: string;
  to: string;
  children?: React.ReactNode;
  icon?: IconProp;
  disabled?: boolean;
}

const LinkCard: React.FC<LinkCardProps> = ({
  oldSchoolLink = false,
  title,
  linkText,
  to,
  children,
  icon = faChevronRight, // Default icon
  disabled = false,
}) => {
  if (disabled) {
    return (
      <div className={`flex-grow-1 ${styles["link-card"]}`} style={{ opacity: 0.5, pointerEvents: "none" }}>
        <Card className={` ${styles["card-layout"]}`}>
          <CardBody className="!p-[1.2rem]">
            <CardTitle
              tag="h5"
              className={`text-center bg-clip-padding !mb-[1.5rem] !text-[1.3924rem] !text-[#444444] !font-medium`}
            >
              {title}
            </CardTitle>
            {children}
          </CardBody>
          <CardFooter
            className={`text-center text-blue-500 bg-white ${styles["card-footer"]}`}
            style={{ color: "#196ECF" }}
          >
            {linkText} <FontAwesomeIcon icon={icon} className="text-xs" />
          </CardFooter>
        </Card>
      </div>
    );
  }

  return oldSchoolLink ? (
    <a href={to} className={`${styles["link-card"]} flex-grow-1`}>
      <Card className={`mb-3 ${styles["card-layout"]}`}>
        <CardBody className={"text-blue-700 p-0 !p-[1.2rem]"}>
          <CardTitle
            tag="h5"
            className={`text-center bg-clip-padding !mb-[1.5rem] !text-[1.3924rem] !text-[#444444] !font-medium`}
          >
            {title}
          </CardTitle>
          {children}
        </CardBody>
        <CardFooter
          className={`text-center text-blue-500 bg-white  ${styles["card-footer"]}`}
          style={{ color: "#196ECF" }}
        >
          {linkText} <FontAwesomeIcon icon={icon} className="text-xs" />
        </CardFooter>
      </Card>
    </a>
  ) : (
    <Link href={to} passHref className={`flex-grow-1 ${styles["link-card"]}`}>
      <Card className={` ${styles["card-layout"]}`}>
        <CardBody className="!p-[1.2rem]">
          <CardTitle
            tag="h5"
            className={`text-center bg-clip-padding !mb-[1.5rem] !text-[1.3924rem] !text-[#444444] !font-medium`}
          >
            {title}
          </CardTitle>
          {children}
        </CardBody>
        <CardFooter
          className={`text-center text-blue-500 bg-white ${styles["card-footer"]}`}
          style={{ color: "#196ECF" }}
        >
          {linkText} <FontAwesomeIcon icon={icon} className="text-xs" />
        </CardFooter>
      </Card>
    </Link>
  );
};

export default LinkCard;
